import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { ResultResponse } from '../../models/result';
import { Subscription } from "../../models/subscriptions";
import FullScreenLoader from '../../shared/components/FullScreenLoader';
import { InfoPlate } from '../../shared/components/InfoPlate';
import LogoBar from '../../shared/components/LogoBar';
import CommonServerList from '../../shared/components/ServerList';
import '../../shared/components/styles/RainbowPulse.css';
import { useCreateSubscription } from '../../shared/hooks/useCreateSubscription';
import './WelcomeScreen.css';
import { getTelegramWebApp } from '../../utils/telegram';

type WelcomeScreenProps = {
	onSuccess: () => void;
}

function isSubscription(sub: ResultResponse<Subscription>): boolean {
	return sub.success;
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onSuccess }) => {

	const { createSubscriptionAsync, isLoading: mutationLoading } = useCreateSubscription();
	const [started, setStarted] = useState(false);

	const onCreateClick = async () => {
		setStarted(true);
		let created: ResultResponse<Subscription>;

		try {
			if (process.env.NODE_ENV === 'development') {
				created = await createSubscriptionAsync(undefined);
			} else {
				const startParam = getTelegramWebApp()?.initDataUnsafe?.start_param;

				if (startParam) {
					const launchParams = JSON.parse(atob(startParam));

					if (launchParams?.ref) {
						created = await createSubscriptionAsync(launchParams.ref);
					} else {
						toast.error('Некорректные параметры запуска');
						setStarted(false);
						return;
					}
				} else {
					created = await createSubscriptionAsync(undefined);
				}
			}

			if (isSubscription(created)) {
				toast.success("🎉 Бесплатный пробный период активирован! Посмотрите инструкцию по настройке.");
				onSuccess();
			} else {
				toast.error("Ошибка при активации подписки");
				setStarted(false);
			}
		} catch (err) {
			console.log(err);
			setStarted(false);
			toast.error('Ошибка при активации подписки');
		}
	};

	if (mutationLoading || started) return <FullScreenLoader />;

	return (
		<div className='welcome-screen-container'>
			<LogoBar />
			<InfoPlate>
				<div>Добро пожаловать в Ogo Secure Access!</div>
				<div>Нажмите кнопку ниже, чтобы начать пробный период.</div>
				<div>Получите ссылку на конфигурацию и импортируйте ее в любое удобное для вас приложение.</div>
				<div>Мы постоянно работает над улучшением сервиса, и скоро будем добавлять новые сервера для вас.</div>
			</InfoPlate>

			<button
				style={{ border: 'none' }}
				type="button"
				className="img-button try-button liquidGlass-wrapper menu pulse"
				onClick={onCreateClick}>
				<div className="liquidGlass-effect"></div>
				<div className="liquidGlass-tint"></div>
				<div className="liquidGlass-shine"></div>
				<div className="try-button-text liquidGlass-text rainbow-pulse">
					СОЗДАТЬ ПОДПИСКУ И НАЧАТЬ
				</div>
			</button>

			<div style={{ marginTop: '20px' }}
				className="server-list-title">Доступные сервера:</div>
			<CommonServerList isInternal={false} />
		</div>
	);
};

export default WelcomeScreen;
